import(/* webpackMode: "eager" */ "/vercel/path0/src/app/masters/page.tsx");
